export const CHART_VARIANTS = {
    MAP: "map",
    PIE: "pie",
} as const;

export type ChartVariant = (typeof CHART_VARIANTS)[keyof typeof CHART_VARIANTS];
